export default function TextAPI() {
  const bannerText = window.PVPSiteBanner;

  return {
    bannerText,
  };
}
